import pmPageNumber from './PageNumberPM';

export default function (leftPageID, sections, paperTypeID) {
  return pmPageNumber(leftPageID, sections, paperTypeID);
}
